import classNames from 'classnames'
import { AnchorLink } from 'gatsby-plugin-anchor-links'
import { withPrefix } from 'gatsby'
import React from 'react'
import { pagesPath } from '../../lib/pagesPath'
import { SectionTitle } from '../general/section-title'
import * as Styles from './tool.module.scss'

export function Tool({ sectionTitle, notLink = false, ...props }) {
  return (
    <div
      {...props}
      id="tool"
      className={classNames(Styles.tool, props.className)}
    >
      <SectionTitle as="h2" en="FUNCTIONS">
        {sectionTitle ? (
          sectionTitle
        ) : (
          <>
            <img
              src={withPrefix('/service_logo.svg')}
              alt="Uniforce(ユニフォース)クラウド決算開示管理サービス"
              width={194.43}
              height={44.55}
            />
            の主な機能
          </>
        )}
      </SectionTitle>
      <ul>
        <li>
          <div className={Styles.tool__img_wrapper}>
            <img
              src={withPrefix('/tool_icon_list_1.svg')}
              alt=""
              width={104.95}
              height={103.8}
            />
          </div>
          <h3>自動スケジュール生成機能</h3>
          <p>決算開示業務の理想的なスケジュールを自動生成します。</p>
        </li>
        <li>
          <div className={Styles.tool__img_wrapper}>
            <img
              src={withPrefix('/tool_icon_list_2.svg')}
              alt=""
              width={96.35}
              height={91.69}
            />
          </div>
          <h3>タスクナビゲーション</h3>
          <p>次に行うべきタスクへ流れるようにナビゲートします。</p>
        </li>
        <li>
          <div className={Styles.tool__img_wrapper}>
            <img src={withPrefix('/tool_icon_list_3.svg')} alt="" width={85.87} height={75} />
          </div>
          <h3>書類進捗サマリー</h3>
          <p>開示書類ごとの進捗を管理することが可能です。</p>
        </li>
        <li>
          <div className={Styles.tool__img_wrapper}>
            <img
              src={withPrefix('/tool_icon_list_4.svg')}
              alt=""
              width={74.58}
              height={86.64}
            />
          </div>
          <h3>各タスクへのコメント</h3>
          <p>
            詳細タスクごとにコメントを
            <br />
            行うことが可能です。
          </p>
        </li>
        <li>
          <div className={Styles.tool__img_wrapper}>
            <img
              src={withPrefix('/tool_icon_list_5.svg')}
              alt=""
              width={75.38}
              height={86.89}
            />
          </div>
          <h3>期限切れアラート</h3>
          <p>
            期限切れのタスクが
            <br />
            アラート表示されます。
          </p>
        </li>
        <li>
          <div className={Styles.tool__img_wrapper}>
            <img
              src={withPrefix('/tool_icon_list_6.svg')}
              alt=""
              width={63.63}
              height={81.92}
            />
          </div>
          <h3>各タスクのステータス設定</h3>
          <p>
            タスクの現状ステータスを
            <br />
            細かく設定することができます。
          </p>
        </li>
        <li>
          <div className={Styles.tool__img_wrapper}>
            <img src={withPrefix('/tool_icon_list_7.svg')} alt="" width={101.5} height={74} />
          </div>
          <h3>メンバー管理</h3>
          <p>
            登録されているメンバーを一覧で
            <br />
            確認、管理することができます。
          </p>
        </li>
        <li>
          <div className={Styles.tool__img_wrapper}>
            <img
              src={withPrefix('/tool_icon_list_8.svg')}
              alt=""
              width={70.55}
              height={76.7}
            />
          </div>
          <h3>書類・タスク軸の切替表示</h3>
          <p>
            書類軸、タスク軸で
            <br />
            切り替えて表示できます。
          </p>
        </li>
        <li>
          <div className={Styles.tool__img_wrapper}>
            <img
              src={withPrefix('/tool_icon_list_9.svg')}
              alt=""
              width={143.29}
              height={72.9}
            />
          </div>
          <h3>前年度との比較</h3>
          <p>
            前年度のタスク状況と今年度の
            <br />
            タスクの進行を比較できます。
          </p>
        </li>
      </ul>
      {!sectionTitle && !notLink && (
        <div className={Styles.tool__btn}>
          <AnchorLink to={pagesPath.tool.$url()}>詳しく見る</AnchorLink>
        </div>
      )}
    </div>
  )
}
